<script>
  export let message = "";
  export let customClass = "";
  export let sticky = "sticky";
</script>

<div class={`top-0 max-w-full bg-red-500 text-white text-center py-8 px-4 z-50 text-2xl break-words ${customClass} ${sticky ? sticky : ''}`}>
  {message}
</div>